<template>
  <v-app :class="{ 'app-login': !auth }">
    <app-sidenav v-if="auth && sidenav"></app-sidenav>
    <app-navbar v-if="auth"></app-navbar>
    <v-content v-if="main">
      <!-- <app-breadcrumbs v-if="auth"></app-breadcrumbs> -->
      <div class="main pt-3">
        <transition :name="transitionName" mode="out-in">
          <router-view />
        </transition>
      </div>
    </v-content>
    <app-notification></app-notification>
    <app-footer></app-footer>
    <app-messages></app-messages>
    <app-alert></app-alert>
    <app-confirm></app-confirm>
    <vue-progress-bar></vue-progress-bar>
    <app-loading></app-loading>
  </v-app>
</template>

<script>
import AppSidenav from "@/common/layout/AppSidenav";
import AppNavbar from "@/common/layout/AppNavbar";
import AppFooter from "@/common/layout/AppFooter";
import AppBreadcrumbs from "@/common/layout/AppBreadcrumbs";
import AppMessages from "@/common/plugins/message/AppMessages";
import AppLoading from "@/common/plugins/loading/AppLoading";
import AppNotification from "@/common/layout/AppNotification";
import AppAlert from "@/common/plugins/modal/AppAlert";
import AppConfirm from "@/common/plugins/modal/AppConfirm";
import Auth from "@/components/admin/auth/mixins/auth";
import { mapState } from "vuex";

// Páginas que no necesitan autenticación/token/sesión
const PageNoLogin = ["login", "loginlock", "login-ciudadania", "login-nit","password-recovery"];

export default {
  name: "App",
  mixins: [Auth],
  created() {
    const error = this.$storage.get("error");
    if (error) {
      this.$message.error(error);
      this.$storage.remove("error");
    }
    console.log('this.$storage.existUser()', this.$storage.existUser())
    if (this.$storage.existUser()) {
      this.$store.commit("setAuth", true);
      

      if (this.$storage.exist("sidenav")) {
        this.$store.commit("setSidenav", this.$storage.get("sidenav"));
      }

      if (this.$storage.exist("permissions")) {
        this.$store.commit("setPermissions", this.$storage.get("permissions"));
      }

      this.timerSession();
    } else {
      console.log('no logueado correctamente........')
      if (
        PageNoLogin.indexOf(this.$route.path.substring(1)) === -1 ||
        this.$route.path === "/"
      ) {
        this.logout();
      }
    }

    // loading bar config
    this.$Progress.start();
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress;
        this.$Progress.parseMeta(meta);
      }
      this.$Progress.start();
      next();
    });
    this.$router.afterEach((to, from) => {
      this.$Progress.finish();
    });

    // Cargando
    this.$util.events();
  },
  data: () => ({
    transitionName: ""
  }),
  components: {
    AppSidenav,
    AppNavbar,
    AppFooter,
    AppBreadcrumbs,
    AppMessages,
    AppNotification,
    AppAlert,
    AppConfirm,
    AppLoading
  },
  computed: {
    ...mapState(["auth", "sidenav", "main"])
  },
  watch: {
    $route(to, from) {
      if (
        !this.$storage.existUser() &&
        PageNoLogin.indexOf(to.path.substring(1)) === -1
      ) {
        this.logout();
      }
      if (to.path !== "/login" && from.path !== "/login") {
        this.transitionName = "fade";
      } else {
        this.transitionName = "";
      }
      this.$store.commit("closeModal");
    }
  }
};
</script>

<style lang="scss">
@import "assets/scss/index.scss";
$filterBackground: #e1f5f0;
$filterBorder: #e5e5e5;
.mayuscula input {
  text-transform: uppercase;
}
.text-field-reducido {
  padding: 0em 0em 0em 0em;
  margin: 0em 0em 0em 0em;
  .v-input__control {
    padding: 0em 0em 0em 0em;
    margin: 0em 0em 0em 0em;
    .v-text-field__slot {
      padding: 0em 0em 0em 0em;
      margin: 0em 0em 0em 0em;
      .input {
        padding: 0em 0em 0em 0em;
        margin: 0em 0em 0em 0em;
      }
    }
    .v-input__slot {
      padding: 0em 0em 0em 0em;
      margin: 0em 0em 0em 0em;
    }
    .v-text-field__details {
      padding: 0em 0em 0em 0em;
      margin: 0em 0em 0em 0em;
      .v-messages {
        padding: 0em 0em 0em 0em;
        margin: 0em 0em 0em 0em;
      }
    }
  }
}
.text-field-reducido-border {
  padding: 0em 0em 0em 0em;
  margin: 0em 0em 0em 0em;
  .v-input__control {
    padding: 0em 0em 0em 0em;
    margin: 0em 0em 0em 0em;
    .v-text-field__slot {
      padding: 0em 0em 0em 0em;
      margin: 0em 0em 0em 0em;
      .input {
        padding: 0em 0em 0em 0em !important;
        margin: 0em 0em 0em 0em;
      }
    }
    .v-input__slot {
      padding: 0em 0em 0em 0em;
      margin: 0em 0em 0em 0em;
      border-width: 1px 1px 1px 3px !important;
      //border-width: 1px 2px 3px 4px;
      // border-style: solid dotted dashed double;
      // border-color: #C00 #0C0 #00C #CCC;
    }
    .v-text-field__details {
      padding: 0em 0em 0em 0em;
      margin: 0em 0em 0em 0em;
      .v-messages {
        padding: 0em 0em 0em 0em;
        margin: 0em 0em 0em 0em;
      }
    }
  }
}
.filter-container-rrhh {
  background-color: $filterBackground;
  padding: 10px 15px 10px;
  border: 1px solid $filterBorder;
  position: relative;
  .filter-item {
    display: inline-block;
    margin-right: 10px;
    vertical-align: top;
    padding: 0em 0em 0em 0em;
    margin: 0em 0em 0em 0em;
    .v-text-field {
      padding: 0em 0em 0em 0em;
      margin: 0em 0em 0em 0em;
    }
  }
  & > .btn-filter {
    position: absolute;
    top: -8px;
    right: 0px;
  }
  & > .v-icon {
    display: inline-block;
    margin: 14px 5px 0 0;
  }
}
#cabecera_tabla {
  background: rgba(0, 62, 112, 0.808);
  font-weight: bold;
  color: white;
}
.header-comprimido-tabla{
  background: rgb(180, 218, 233);
  white-space: pre-line !important;
  padding: 0em 0.5em 0em 0.5em;
}
.tabla-comprimida-light {
  th {
    .v-icon {
      color: #1E5976 !important;
    }
    column-width: 100%;
    white-space: pre-line !important;
    padding: 0em 0.5em 0em 0.5em !important;
    background: rgb(180, 218, 233);
    font-weight: bold !important;
    color: #347b9e !important;
  }
  td {
    padding: 0em 0.5em 0em 0.5em !important;
  }
}
.celda-comprimida {
  table {
    th,
    td {
      height: 10px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue